module.exports = __webpack_public_path__ + "assets/img/img-detail-bottom-sp.92c6ed73.jpg";